import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-chart-column",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  data: function data() {
    return {
      uuid: null,
      chartOption: {},
      chart: undefined,
      cptData: {}
    };
  },
  watch: {
    'option.attribute': {
      handler: function handler(newObj) {
        this.loadChart(newObj);
      },
      deep: true //深度监听

    },
    width: function width() {
      this.chart.resize();
    },
    height: function height() {
      this.chart.resize();
    }
  },
  created: function created() {
    this.uuid = require('uuid').v1();
  },
  mounted: function mounted() {
    this.chart = this.$echarts.init(document.getElementById(this.uuid));
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "ChartColumn").then(function (res) {
        _this.cptData = res;

        _this.loadChart(_this.option.attribute);
      });
    },
    loadChart: function loadChart(attribute) {
      var that = this;
      var columnColor = attribute.barColor;

      if (attribute.gradualColor) {
        columnColor = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: attribute.barColor1
        }, {
          offset: 0.5,
          color: attribute.barColor2
        }, {
          offset: 1,
          color: attribute.barColor3
        }]);
      }

      that.chartOption = {
        color: columnColor,
        title: {
          text: attribute.chartTitle,
          textStyle: {
            color: attribute.titleTextColor
          },
          left: attribute.titleLeft,
          top: attribute.titleTop
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          x: 10,
          y: 30,
          x2: 10,
          y2: 10,
          containLabel: true
        },
        xAxis: {
          show: attribute.xAxisShow,
          type: 'category',
          data: this.cptData.xData.split(','),
          axisLabel: {
            color: attribute.xLabelColor,
            rotate: attribute.xFontRotate //倾斜角度-180~180

          },
          axisLine: {
            show: attribute.xLineShow,
            lineStyle: {
              color: attribute.xLineColor
            }
          },
          axisTick: {
            //x轴刻度线
            show: attribute.xTickShow
          }
        },
        yAxis: {
          show: attribute.yAxisShow,
          type: 'value',
          axisLabel: {
            color: attribute.yLabelColor
          },
          axisLine: {
            show: attribute.yLineShow,
            lineStyle: {
              color: attribute.yLineColor
            }
          },
          axisTick: {
            //y轴刻度线
            show: attribute.yTickShow
          },
          splitLine: {
            //网格线
            show: attribute.yGridLineShow
          }
        },
        series: [{
          data: this.cptData.yData.split(','),
          type: attribute.barType,
          showBackground: attribute.barBgShow,
          symbol: attribute.barPath,
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
          },
          barWidth: attribute.barWidth,
          itemStyle: {
            borderRadius: attribute.barBorderRadius
          },
          label: {
            show: attribute.barLabelShow,
            //开启显示
            position: 'top',
            //在上方显示
            color: attribute.barLabelColor,
            fontSize: attribute.barLabelSize
          }
        }]
      };
      that.chart.setOption(that.chartOption);
    }
  }
};